module.exports = __webpack_public_path__ + "media/welcome-message/meetup@3x-67b09d3f.png";